import gql from 'graphql-tag';

/**
 * Defines the fields which are requested for an messageBoilerplate
 * used for all queries/mutations which return an messageBoilerplate, and by the block
 * project-email.
 * @type {DocumentNode}
 */
export const MESSAGE_BOILERPLATE_REQUEST_FIELDS = gql`
  fragment messageBoilerplateFields on MessageBoilerplate {
    id
    number
    type
    attachmentType
    subject
    body
  }
`;
